var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 6C4.40647 6 2 8.40647 2 11.375V17.25C2 18.4926 3.00736 19.5 4.25 19.5H12C12.4142 19.5 12.75 19.1642 12.75 18.75V11.375C12.75 8.40647 10.3435 6 7.375 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.1094 3.00464C13.1095 2.17631 13.7811 1.50488 14.6094 1.50488H16.5011C17.3288 1.50488 17.9998 2.17596 17.9997 3.00369C17.9995 3.83123 17.3286 4.50201 16.5011 4.50201H14.6093V6H16.7499C19.6494 6 21.9999 8.35051 21.9999 11.25V17.25C21.9999 18.4926 20.9925 19.5 19.7499 19.5H13.5815C13.6895 19.2727 13.7499 19.0184 13.7499 18.75V11.375C13.7499 9.11661 12.5756 7.13249 10.8042 6H13.1093L13.1094 3.00464Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoMail);
export default __webpack_public_path__ + "static/media/DuoMail.e361f185ae581ee47be4c510c1b68f74.svg";
export { ForwardRef as ReactComponent };